import { DataTableAdapter } from "../../../adapters/datatable.adapter";
import { ViewButton } from "../../../models/view-config/view-button.model";
import { ViewColumnField } from "../../../models/view-config/view-column-field.model";
import { ViewImageButton } from "../../../models/view-config/view-image-button.model";
import { ApiService } from "../../../services";
import { UscStoreService } from "../../../services/usc-store/usc-store.service";
import { DialogComponent } from "../../common/dialog/dialog.component";
import { UscDialogComponent } from "../usc-dialog/usc-dialog.component";
import { UscModalComponent } from "../usc-modal/usc-modal.component";
import { UscUserLookupComponent } from "../usc-user-lookup/usc-user-lookup.component";

export class UscUploadedDocumentDataTableAdapter extends DataTableAdapter {

    uscStoreService: UscStoreService;
    apiService: ApiService;

    constructor(view: string, serviceCollection: any, store_team_ID: string) {
        super(view, serviceCollection);
        if (serviceCollection['uscStoreService']) this.uscStoreService = serviceCollection['uscStoreService'];
    }

    public initialize(): void {
        super.initialize();

        var currentUser = this.authService.getAuth();
        var current_view = this.uscStoreService.view_uploaded_documents;
    }

    public getDetailItems(init_filter_fields: boolean): any {
        var params = this.getSearchParams(this.getExecuteScriptType(true, false), this.getCurrentServerSideFilters());
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: "Loading..." });
        this.uscStoreService.getData(this.datatable_view, params).subscribe(
            result => {
                this.data_items = result.items;
                this.processDataItems(this.data_items, init_filter_fields);
                this.is_loading_data = false;
                dlg.dismiss();

                // get total count of data
                var params = this.getSearchParams(this.getExecuteScriptType(false, true));
                this.uscStoreService.getData(this.datatable_view, params).subscribe(
                    result => {
                        this.itemCount = result.total_count;
                        this.pageCount = Math.ceil(this.itemCount / this.pageSize);
                    },
                    err => {
                        console.log(err);
                    }
                );
            },
            err => {
                console.log(err);
            }
        );
    }

    getFieldValueStyle(data_item: any, field: ViewColumnField) {
        var fvc = {};
        //if (data_item.visitor_type == "Business") fvc["background-color"] = "pink";                   // default business bg-color
        if (this.datatable_view == this.uscStoreService.view_store_visit_waiting_appt) {
            if (data_item.visitor_in_store != "Yes") fvc["background-color"] = "pink";                  // customer not in store
            else if (data_item.last_call_customer_time) {                                               // customer called
                var min_date = new Date(1901, 1, 1);
                var last_call_customer_time = new Date(Date.parse(data_item.last_call_customer_time));
                if (last_call_customer_time > min_date) fvc["background-color"] = "#d3ffd3";
            } else if (data_item.me_sub_type == 'Online Appointments' || data_item.me_sub_type == 'Associate Appointments') {
                fvc["background-color"] = "#ffffbf";
            }

        } else if (this.datatable_view == this.uscStoreService.view_store_visit_scheduled_appt) {
            var now = new Date();
            var appt_time = new Date(Date.parse(data_item.appointment_time));
            if (appt_time < now) fvc = { "background-color": "pink" };                                 // late for appt
        } else if (this.datatable_view == this.uscStoreService.view_store_visit_service_completed) {
            if (data_item.dl_sub_type == 'Purchase') fvc["background-color"] = "#d3ffd3";               // purchase
            if (data_item.dl_sub_type == 'No Purchase') fvc["background-color"] = "pink";               // no-purchase
        }
        return fvc;
    }

    public getFieldValue(data_item: any, field: ViewColumnField): any {
        if (data_item && field) {
            var field_value = data_item[field.key];
            if (field.sn_calc_formula) {
                var sn_calc_formula = this.translatorService.translate(null, data_item, field.sn_calc_formula);
                if (sn_calc_formula) {
                    var formula_results = data_item.formula_results;
                    if (field.sn_calc_formula_frequency > 0) {
                        formula_results = this.formulaService.calculateFormulaValuesByItem(this.table_view_config.view_formulas, data_item);
                    }
                    var fr = formula_results.find(f => f.name == sn_calc_formula);
                    field_value = fr.result;
                }
            }

            var isNotScheduledAppt = data_item.me_sub_type == 'Bill Payment' || data_item.me_sub_type == 'Sales Associate';
            switch (field.key) {
                case 'dn_datetime_created': field_value = this.calendarService.getDateText(new Date(Date.parse(field_value)), 'yyyy-MM-dd hh:mm tt'); break;
            }

            return field_value != null ? field_value : 0;
        }
        return null;
    }

    formatContactNumber(phone: string) {
        var formatted = "";
        if (phone && phone.length == 10) {
            formatted = phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        }
        return formatted;
    }

    protected processActionOnViewItem(btn: ViewButton, item: any, field: ViewColumnField) {
        var img_btn = btn as ViewImageButton;
        var loading_message = img_btn.action_loading_message ? img_btn.action_loading_message : "Updating Appointment...";
        var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: loading_message });
        var params = { scheduling_queue_datetime_modified: item.scheduling_queue_datetime_modified };
        this.uscStoreService.processActionOnViewItem(this.datatable_view, item.view_ID, img_btn.action, params).subscribe(
            result => {
                dlg.dismiss();
                if (result && result.errors) {
                    var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, { msgList: ["Unable to process request.  Please contact SalesNOW support."] });
                    modalRef.result.then((result) => { dlg.dismiss(); }, (reason) => { })
                } else {
                    if (img_btn.action == 'action_usc_svt_start_serving') this.uscStoreService.setCurrentView(this.uscStoreService.view_store_visit_serving_now);
                    else if (img_btn.action == 'action_usc_svt_end_service') this.uscStoreService.setGotoItem(item);
                    else if (btn.reload_post_action) this.reloadItems();
                }
            }, error => {
                this.sessionService.log('sn_view_action::' + img_btn.action + ' failed');
                dlg.dismiss();
            }
        )
    }


    public onBtnClick(btn: ViewButton, item: any, field: ViewColumnField) {
        console.log("onBtnClick::" + btn.event);
        var img_btn = btn as ViewImageButton;
        switch (btn.event) {
            case "sn_view_action": {
                if (img_btn.action == 'action_usc_svt_end_service') {
                    //this.processEndServiceAction(img_btn, item, field);
                } else if (img_btn.action == 'action_usc_svt_reassign') {
                    //this.openUserLookup(img_btn, item, field);
                } else if (img_btn.action == 'action_usc_svt_call_customer' || img_btn.action == 'action_usc_svt_start_serving') {
                    var message = `Do you want to call ${item.customer}?`;
                    if (img_btn.action == 'action_usc_svt_start_serving') message = `Do you want to start service with ${item.customer}?`;
                    var modalRef = this.dialogService.showYesNoDlg(DialogComponent, { msg: [message], confirm_label: 'Confirm', cancel_label: 'Cancel' });
                    modalRef.result.then(
                        (result) => { this.processActionOnViewItem(img_btn, item, field); },
                        (reason) => { }
                    );
                } else {
                    this.processActionOnViewItem(img_btn, item, field);
                }
            }
                break;
            case "sn_dialog_action": {
                const modalRef = this.ngbModal.open(UscDialogComponent, { backdrop: 'static', keyboard: false });
                modalRef.componentInstance.parentView = this.datatable_view;
                modalRef.componentInstance.data = item;
                modalRef.componentInstance.dlgType = img_btn.action;
                modalRef.result.then((result) => {
                    var params: any = {};
                    var action = "";
                    //var reload_post_action = btn.reload_post_action;
                    if (img_btn.action == this.uscStoreService.dialog_type_svt_adjust_queue_position) {
                        params = { position_offset: result.position_offset };
                        action = this.uscStoreService.action_svt_move_by_offset;
                    }

                    //var reloadItems = this.reloadItems;
                    var dlg = this.dialogService.showLoadingDlg(DialogComponent, { msg: 'Reloading...' });
                    this.uscStoreService.processActionOnViewItem(this.datatable_view, item.view_ID, action, params).subscribe(
                        result => {
                            dlg.dismiss();
                            if (result && result.errors) {
                                var modalRef = this.dialogService.showDialog(DialogComponent, this.dialogService.dlg_type_confirmation, { msgList: ["Unable to process request.  Please contact SalesNOW support."] });
                                modalRef.result.then((result) => { dlg.dismiss(); }, (reason) => { })
                            } else {
                                if (btn.reload_post_action) this.reloadItems();
                            }
                        }
                    );
                });
            }
                break;
            case "sn_form_action":
                //this.showOutcomeForm(item, img_btn.action, img_btn.action, img_btn.reload_post_action);
                break;
        }
    }

    public isPagingEnabled(): boolean {
        return true;
    }

    public getNoDataMessage(): string {
        return "No Document Found";
    }
}


// WEBPACK FOOTER //
// C:/Azure/Source/Workspaces/SalesNOW/SalesSOLO/WebSites/SalesSOLO.Web.Angular.telesales/src/app/components/usc-store/usc-uploaded-documents/usc-uploaded-document-dt-adapter.ts